import DefaultDatePicker from './DefaultDatePicker';
import $ from '../../vendor/CustomJquery';
import 'air-datepicker';
import { parseDate } from '../Helpers';

export default class DatePicker extends DefaultDatePicker {

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-date-picker');

    this.start();
    return super.initialize();
  }

  start() {
    this.elements.each((index, element) => {
      this.instance( $(element) );
    });
  }

  instance(input) {

    let value = input.val(),
        isWithTimepicker = (input.data('isWithTimepicker') === true);

    let datePicker = input.datepicker({
      language:       this.App.Language.getLocale(),
      dateFormat:     'dd.mm.yyyy',
      autoClose:      true,
      position:       this._DEFAULT_POSITION,
      todayButton:    new Date(),
      clearButton:    true,
      onShow:         (instance, animationComplete) => {
        return this.onShow(instance, animationComplete);
      },
      onHide:         (instance) => {
        return this.onHide(instance);
      },
      onSelect:       (formattedDate, date, instance) => {
        return this.onSelect(formattedDate, date, instance)
      },
      range:          false,
      toggleSelected: false,
      timepicker:     isWithTimepicker
    }).data('datepicker');

    if (value.length > 0) {
      datePicker.selectDate(
        parseDate(value)
      );
    }

    input.on('keydown', function(event) {
      if (event.which === 13 || event.keyCode === 13) {
        event.preventDefault();
        $(this).data('datepicker').selectDate(
          parseDate(this.value)
        );
      }
    });

  }

}